import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../../../components/custom-table/table";
import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../../../data-model/medicalPaOrdersModel";
import { DrugTableForExternalKeys } from "../../../../../enums/tableColumnKeys";
import { getAuthStatusOfOneJCode } from "../../../../../utils/getAuthStatusOfMedicalPaOrder";

export const DrugTableForExternalColumnsKeys: TableHeader[] = [
  {
    label: "Date From",
    key: DrugTableForExternalKeys.StartFrom,
    order: 1,
    width: 10,
    sortable: true,
    type: TableCellType.DATE,
  },
  {
    label: "Date To",
    key: DrugTableForExternalKeys.EndAt,
    order: 1,
    width: 10,
    sortable: true,
    type: TableCellType.DATE,
  },
  {
    label: "J Codes",
    key: DrugTableForExternalKeys.JCodes,
    order: 3,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Description",
    key: DrugTableForExternalKeys.Description,
    order: 4,
    width: 25,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Total Visits",
    key: DrugTableForExternalKeys.Visits,
    order: 5,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Remaining",
    key: DrugTableForExternalKeys.RemainingVisits,
    order: 6,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Completed",
    key: DrugTableForExternalKeys.VisitsAllowed,
    order: 7,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Auth Required",
    key: DrugTableForExternalKeys.PaRequired,
    order: 8,
    width: 15,
    type: TableCellType.BADGE,
  },
];

export const generateDrugTableForExternalData = (
  data: MedicalPaOrder,
  authStatusOptions: AuthStatusOptionModel[],
) => {
  const authEntries = data?.auth_on_file?.auth_entries ?? [];
  const getAllJCodesData = () => {
    let JcodesData: JCodeDetails[] = [];
    authEntries.forEach((item) => {
      JcodesData.push(...(item?.j_codes ?? []));
    });
    return JcodesData;
  };
  const JcodesData = getAllJCodesData();
  return JcodesData.map((item, index) => {
    const authStatus = getAuthStatusOfOneJCode(item, authStatusOptions);

    const description = () => {
      if (item?.description && item?.description !== "") {
        return item?.description;
      }
      return item?.medicine_name?.join(", ") ?? "N/A";
    };

    return {
      [DrugTableForExternalKeys.StartFrom]: item?.start_date
        ? moment(item.start_date).format("MM/DD/YYYY")
        : "",
      [DrugTableForExternalKeys.EndAt]: item?.end_date
        ? moment(item.end_date).format("MM/DD/YYYY")
        : "",
      [DrugTableForExternalKeys.Description]: description(),
      [DrugTableForExternalKeys.PaRequired]: {
        text: authStatus?.text,
        color: authStatus?.textColor,
        bgColor: authStatus?.bgColor,
      },
      [DrugTableForExternalKeys.Visits]: item?.num_visits ?? "0",
      [DrugTableForExternalKeys.RemainingVisits]: item?.visits_remaining ?? "0",
      [DrugTableForExternalKeys.VisitsAllowed]: item?.visits_happened ?? "0",
      [DrugTableForExternalKeys.JCodes]: item?.j_code ?? "N/A",
      [DrugTableForExternalKeys.JCodeID]: item?.id ?? "N/A",
    };
  });
};
